
import React from "react";

import gql from "graphql-tag";

import { graphql, compose } from "react-apollo";


import {
  ResourceNoNestingFragment,
} from "../../../../../schema/generated/api.fragments";


export const createCommentProcessor = gql`
 

mutation createCommentProcessor(
  $data: CommentCreateInput!
){
  response: createCommentProcessor(
    data: $data
  ){
    success
    message
    errors{
      key
      message
    }
    data{
      ...ResourceNoNesting
    }
  }
}

${ResourceNoNestingFragment}

`;


export const updateCommentProcessor = gql`


mutation updateCommentProcessor(
  $data: CommentUpdateInput!
  $where: ResourceWhereUniqueInput!
){
  response: updateCommentProcessor(
    data: $data
    where: $where
  ){
    success
    message
    errors{
      key
      message
    }
    data{
      ...ResourceNoNesting
    }
  }
}

${ResourceNoNestingFragment}

`;

